import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=ab105332&scoped=true&lang=pug&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationList.vue?vue&type=style&index=0&id=ab105332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab105332",
  null
  
)

export default component.exports